import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { useIntersectionObserver, watchDebounced } from '@vueuse/core'
import axios from 'axios'
import localforage from 'localforage'
import { emitter } from '@/plugins/emitter'
import { getFirebaseClient } from '@/plugins/firebase-lib'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import {
  YAGIOFFER_SELF_PR_SAVED,
  fetchYagiofferServerProfile,
  saveLocalYagiofferSelfPr
} from '@/composables/useYagiofferProfileServerSync'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagiofferSelfPrAppendBox',
  setup(__props) {

// 書式編集の自己PRカードの下に置く、ヤギオファー用自己PRの入力欄。
// 書式の自己PRは応募先向けでそのままでは使いにくいため、別の文章として書いてもらう。
// 保存はほかの入力と同じく basicData.yagiofferSelfPr への自動保存のみ。サーバーへは
// 書式編集のバックアップ（save_backupdata → yagi_offer_member_profile へ抽出）で届く。
const PLACEHOLDER =
  '例）\n・来年の春までに転職したい。リモート勤務ができると嬉しい\n・前職で身につけた〇〇のスキルを活かしたい\n・今後は〇〇の分野に挑戦したい'

const { varuna } = useHostServices()

const rootEl = ref<HTMLElement | null>(null)
const editSelfPr = ref('')
// 読み込み完了までは自動保存しない（空欄の初期値で保存済みの自己PRを消さないため）
const isReady = ref(false)
// 最後に basicData にある値。同じ値の書き直し（「おぼえた」通知の空打ち）を避ける
let lastSaved = ''

onMounted(async () => {
  try {
    const basicData = (await localforage.getItem('basicData')) as any
    lastSaved = (basicData && basicData.yagiofferSelfPr) || ''
    // 読み込み中に書き始めていたら、その入力は消さない
    if (!editSelfPr.value) editSelfPr.value = lastSaved
    isReady.value = true
  } catch (err) {
    console.error(err)
  }
})

// 別端末で更新された自己PRはサーバーにしか無い。この端末の古い値のまま
// バックアップされると巻き戻るので、サーバー値で表示とローカルを揃える
async function syncFromServer() {
  const shown = editSelfPr.value
  const result = await fetchYagiofferServerProfile({
    $firebase: getFirebaseClient(),
    $axios: axios,
    $varuna: varuna
  } as any)
  const serverSelfPr = result.ok && result.profile && result.profile.selfPr
  if (isReady.value && serverSelfPr && editSelfPr.value === shown) {
    editSelfPr.value = serverSelfPr
  }
}

// 自己PRカードは v-show で他ステップ表示中もマウントされているため、
// サーバー照会は初めて画面に入ったときだけ行う
const { stop } = useIntersectionObserver(rootEl, ([entry]) => {
  if (!entry || !entry.isIntersecting) return
  stop()
  syncFromServer()
})

watchDebounced(
  editSelfPr,
  async (value) => {
    if (!isReady.value) return
    const selfPr = value.trim()
    if (selfPr === lastSaved) return
    lastSaved = selfPr
    // 書式編集の基本情報カードは basicData をメモリに丸ごと持って保存し直すため、
    // そちらにも反映しないと古い自己PRで上書きされる
    emitter.emit(YAGIOFFER_SELF_PR_SAVED, selfPr)
    const basicData = await saveLocalYagiofferSelfPr(selfPr)
    if (basicData) emitter.emit('basic-data-changed', basicData)
  },
  { debounce: 1000 }
)

return { __sfc: true,PLACEHOLDER, varuna, rootEl, editSelfPr, isReady, lastSaved, syncFromServer, stop }
}

})